module.exports = __webpack_public_path__ + "img/overspeed-sq.786a96f0.svg";